<div class="d-flex justify-content-start align-items-center drop-downs">
    <div>
        <div>
            <label>Brand:</label>
        </div>
        <nz-select
            nzPlaceHolder="Select brand"
            nzAllowClear="true"
            [(ngModel)]="selectedBrandId"
            class="dropdown-selector"
            (ngModelChange)="onBrandChange()"
        >
            <nz-option
                [nzValue]="brand.id"
                [nzLabel]="getShortId(brand.id)"
                *ngFor="let brand of availableBrandValues"
            ></nz-option>
        </nz-select>
    </div>
    <div>
        <div>
            <label>Department:</label>
        </div>
        <nz-select
            class="dropdown-selector"
            nzPlaceHolder="Select department"
            nzAllowClear="true"
            [(ngModel)]="selectedDepartmentId"
            (ngModelChange)="onDepartmentChange()"
        >
            <nz-option
                [nzValue]="department.id"
                [nzLabel]="department.name"
                *ngFor="let department of availableDepartmentValues"
            ></nz-option>
        </nz-select>
    </div>
    <div>
        <div>
            <label>Season:</label>
        </div>
        <nz-select
            nzPlaceHolder="Select season"
            nzAllowClear="true"
            [(ngModel)]="selectedRangeId"
            class="dropdown-selector"
            (ngModelChange)="onSeasonChange()"
        >
            <nz-option
                [nzValue]="range.id"
                [nzLabel]="range.label"
                *ngFor="let range of availableRanges"
            ></nz-option>
        </nz-select>
    </div>
</div>